import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { http } from "../services/http.service";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { updateBussinessData } from "../services/auth.service";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBussinessData } from "../store/actions/action";

function LanguageChanger({ displayType = "buttons" }) {
  const [message, setMessage] = useState("");
  const [showAll, setShowAll] = useState(false);
  const { bussinessUuid } = useParams();
  const business = useSelector((state) => state.bussiness.business);
  const dispatch = useDispatch();

  const [selectedLanguage, setSelectedLanguage] = useState(
    business?.language || ""
  );
  const languages = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिंदी" },
    { code: "pa", label: "ਪੰਜਾਬੀ" },
    { code: "mr", label: "मराठी" },
    { code: "gu", label: "ગુજરાતી" },
    { code: "ta", label: "தமிழ்" },
    { code: "te", label: "తెలుగు" },
    { code: "kn", label: "ಕನ್ನಡ" },
    { code: "ml", label: "മലയാളം" },
    { code: "bn", label: "বাংলা" },
    { code: "or", label: "ଓଡିଆ" },
    { code: "ur", label: "اردو" },
  ];

  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (selectedLanguage) {
      changeLanguage(selectedLanguage);

      const userRole = localStorage.getItem("role");
      if (userRole === "owner_admin") {
        updateBussinessData(bussinessUuid, { language: selectedLanguage });
        dispatch(getBussinessData(bussinessUuid));
      }
    }
  }, [selectedLanguage]);

  const changeLanguage = (lng) => {
    http.configureAxios(); // Ensure that Axios is configured before making the request
    i18n.changeLanguage(lng);
    localStorage.setItem("lng", lng);
    setSelectedLanguage(lng);
  };

  const displayedLanguages = showAll ? languages : languages.slice(0, 6);

  return (
    <div className='App'>
      {displayType === "buttons" ? (
        <div>
          {displayedLanguages.map((language, index) => (
            <span key={language.code}>
              <button
                onClick={() => changeLanguage(language.code)}
                className={`shadow-none px-2 py-1 rounded-md ${
                  selectedLanguage === language.code
                    ? "bg-blue-600 text-white dark:bg-gray-700 dark:text-white"
                    : "bg-gray-200 text-gray-800 dark:bg-[#170f2a] dark:border-[#170f2a] dark:text-gray-200"
                }`}
              >
                {language.label}
              </button>

              {index < displayedLanguages.length - 1 && ", "}
            </span>
          ))}
        </div>
      ) : (
        <div>
          <select
            style={{
              height: "2.5rem",
              width: "9.5rem",
              padding: "5px",
              borderRadius: "0.5rem",
              boxShadow: "none",
            }}
            className='bg-white text-gray-800 dark:bg-[#020617] dark:text-white '
            onChange={(e) => changeLanguage(e.target.value)}
            value={selectedLanguage}
            name={"lng"}
            id={"lng"}
          >
            <option value='' disabled className='dark:bg-[#020617]'>
              {t("CARD.SELECT_LANGUAGE")}
            </option>
            {languages.map((language) => (
              <option
                key={language.code}
                value={language.code}
                className='dark:bg-[#020617]'
              >
                {language.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {displayType === "buttons" && (
        <button
          className='bg-gray-400 px-1 py-1 text-sm rounded text-white font-semibold flex items-center justify-center ml-0 absolute top-6 dark:bg-gray-700 dark:text-white'
          style={{ boxShadow: "none" }}
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? (
            <IoIosArrowUp className='text-l' />
          ) : (
            <IoIosArrowDown className='text-l' />
          )}
        </button>
      )}

      <p className='text-gray-800 dark:text-white'>{message}</p>
    </div>
  );
}

export default LanguageChanger;
